// Libraries
import { Flex, Modal, ModalContent, ModalOverlay } from '@chakra-ui/react';
// Types
import { ModalWrapperProps } from './ModalWrapper.types';

/**
 * ModalWrapper component represents a wrapper for a modal.
 *
 * @component
 * @param {ModalWrapperProps} props - The component props.
 * @param {boolean} props.isModalOpen - Specifies whether the modal is open or closed.
 * @param {Function} props. closeModal - Callback function to close the modal.
 * @returns {ReactElement} The ModalWrapper component.
 */
export const ModalWrapper = ({ isModalOpen, closeModal, children }: ModalWrapperProps) => {
  return (
    <Modal isOpen={isModalOpen} onClose={closeModal} size='xl'>
      <ModalOverlay />
      <ModalContent>
        <Flex px={6} py={5} gap={4} direction='column' position='relative'>
          {children}
        </Flex>
      </ModalContent>
    </Modal>
  );
};
